export enum VidMuseEvent {
  // Custom Events

  // Page Events
  HomePageDisplayed = "home_page_displayed",
  ThreadListPageDisplayed = "thread_list_page_displayed",
  ThreadDetailPageDisplayed = "thread_detail_page_displayed",
  LoginPageDisplayed = "login_page_displayed",
  ThreadSharePageDisplayed = "thread_share_page_displayed",

  // Home Page
  HomePageCreateThread = "home_create_thread",

  // Thread Page
  ThreadPageTryForFreeBtnClick = "thread_page_try_for_free_btn_click",

  // Thread Events
  ThreadSendMessage = "thread_send_message",
  ThreadContinue = "thread_continue",

  // Artifacts
  ArtifactResultVideoDisplay = "artifact_result_video_display",
  ArtifactResultVideoClick = "artifact_result_video_click",
  ArtifactResultVideoDownload = "artifact_result_video_download",
  ArtifactProjectDownload = "artifact_project_download",
  ArtifactSharePopoverOpened = "artifact_share_popover_opened",
  ArtifactShareSocialBtnClick = "artifact_share_social_btn_click",
  ArtifactShareCopyBtnClick = "artifact_share_copy_btn_click",

  // Share Page
  ThreadSharePageRemix = "thread_share_page_remix",
  ThreadSharePageOpenProject = "thread_share_page_open_project",
  ThreadSharePageShareSocialBtnClick = "thread_share_page_share_social_btn_click",
  ThreadSharePageCopyLinkBtnClick = "thread_share_page_copy_link_btn_click",

  // Media Editor Modal Events
  MediaEditorModalOpened = "media_editor_modal_opened",
  MediaEditorModalGenerateBtn = "media_editor_modal_generate_click",
  MediaEditorModalReplaceBtn = "media_editor_modal_replace_click",
  MediaEditorModalRemixBtn = "media_editor_modal_remix_click",
  MediaEditorModalSelectVersionBtn = "media_editor_modal_select_version_click",
  MediaEditorModalDownloadBtn = "media_editor_modal_download_click",
}
